import React, { useState, Fragment } from "react";
import {
  StyledDropDown,
  StyledDropDownBtn,
  StyledDropDownContant,
  StyledDropDownItem,
} from "./SubMenue.style";
import { Link } from "react-router-dom";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import ChairIcon from "@mui/icons-material/Chair";

export default function SubMenu({
  selected,
  setSelected,
  menuTitle,
  categoris,
  link,
  ChairMenu,
  menuTitleLink,
  color,
}) {
  const [isActive, setActive] = useState(false);

  return (
    <>
      <StyledDropDown>
        <StyledDropDownBtn onClick={(e) => setActive(!isActive)}>
          <Link
            to={menuTitleLink}
            style={{
              color: color ? color : "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            {ChairMenu ? (
              <ChairIcon style={{ fontSize: "18px", marginLeft: "10px" }} />
            ) : (
              <BeachAccessIcon
                style={{ fontSize: "18px", marginLeft: "10px" }}
              />
            )}
            {menuTitle}
          </Link>
          <StyledDropDownContant className="dropdown">
            {categoris.map((category, index) => (
              <Fragment key={"list" + index}>
                {category.title ? (
                  <Link to={`${link}/${category.id}`}>
                    {ChairMenu ? (
                      <ChairIcon
                        style={{ fontSize: "18px", marginLeft: "10px" }}
                      />
                    ) : (
                      <BeachAccessIcon
                        style={{ fontSize: "18px", marginLeft: "10px" }}
                      />
                    )}
                    {category.title}
                  </Link>
                ) : (
                  ""
                )}
                {/* {category.length < 1 ? ( */}

                {/* ) : (
                <h></h>
                )} */}
              </Fragment>
            ))}
          </StyledDropDownContant>
        </StyledDropDownBtn>
      </StyledDropDown>
    </>
  );
}
